const map: Record<string, string> = {
  a: 'á', b: 'ƀ', c: 'ç', d: 'đ', e: 'é', f: 'ƒ', g: 'ĝ', h: 'ĥ', i: 'í', j: 'ĵ', k: 'ķ', l: 'ľ', m: 'ḿ',
  n: 'ń', o: 'ó', p: 'ƥ', q: 'ʠ', r: 'ř', s: 'š', t: 'ŧ', u: 'ú', v: 'ṽ', w: 'ŵ', x: 'ẋ', y: 'ý', z: 'ž',
};

export function pseudolocalize(input: string): string {
  const tokens: string[] = [];
  const protectedInput = input.replace(/(\{[^}]+\}|%\w|CVE-\d{4}-\d+|https?:\/\/\S+)/g, (token) => {
    tokens.push(token);
    return `__TOKEN_${tokens.length - 1}__`;
  });
  const transformed = protectedInput.split('').map((char) => map[char.toLowerCase()] ?? char).join('');
  const expanded = `[!! ${transformed} ${'~'.repeat(Math.max(3, Math.ceil(input.length * 0.25)))} !!]`;
  return expanded.replace(/__TOKEN_(\d+)__/g, (_, index) => tokens[Number(index)]);
}
